//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "FactorGroupItemModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "环境监测因子组指标表单",
      tableName: "site_factor_group_item",
      form_fields: ['groupId', 'factorId', 'sort', 'tenantId'],
      form_fields_time: [],
      validatorRules: {
        groupId: {
          rules: [{
            required: true,
            message: '请输入因子组ID!'
          }]
        },
        factorId: {
          rules: [{
            required: true,
            message: '请输入监测因子ID!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};